const tab_sections = {
    identity: '身份与组织',
    integrations: '应用与接入',
    login_security: '登录与安全',
    permissions: '权限与资源',
    automation: '自动化与审计',
    platform: '平台',
    overview: '概览',
    authentication: '身份验证',
    authorization: '授权',
    users: '用户',
    developer: '开发者',
    tenant: '租户',
};
export default Object.freeze(tab_sections);
